import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=03b510bd"
import script from "./CreateUserDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports